export type NumericValue = number | string | null | undefined;
export type TimeRange = "24h" | "7d" | "30d" | "90d" | "12m";

export interface FinanceData {
  success: boolean;
  time_range: string;
  financial_metrics: {
    subscription_revenue: NumericValue;
    topup_revenue: NumericValue;
    total_revenue: NumericValue;
    monthly_recurring_revenue: NumericValue;
    average_revenue_per_user: NumericValue;
    gross_profit: NumericValue;
    profit_margin: NumericValue;
    conversion_rate: NumericValue;
    churn_rate: NumericValue;
    revenue_growth_rate: NumericValue;
    customer_lifetime_value: NumericValue;
  };
  operational_costs: {
    total_monthly_costs: NumericValue;
    ai_cost: NumericValue;
  };
  ai_metrics: {
    filtered_period?: {
      resumes_processed?: NumericValue;
      cost_estimate?: NumericValue;
      projected_monthly_cost?: NumericValue;
    };
    lifetime_summary?: {
      total_resumes_processed?: NumericValue;
      total_cost_estimate?: NumericValue;
      avg_cost_per_resume?: NumericValue;
    };
    cost_breakdown?: {
      model?: string;
      total_input_cost?: NumericValue;
      total_output_cost?: NumericValue;
      rates?: {
        input_cost_per_1k_tokens?: NumericValue;
        output_cost_per_1k_tokens?: NumericValue;
      };
    };
    token_usage?: {
      total_tokens_used?: NumericValue;
      total_input_tokens?: NumericValue;
      total_output_tokens?: NumericValue;
      lifetime_averages_per_resume?: {
        input?: NumericValue;
        output?: NumericValue;
        total?: NumericValue;
      };
    };
  };
  credits_metrics: {
    total_credits_purchased: NumericValue;
    total_credits_used: NumericValue;
    credit_usage_rate: NumericValue;
  };
  subscription_breakdown: {
    revenue_by_tier: Record<string, NumericValue>;
    new_subscriptions: NumericValue;
    cancelled_subscriptions: NumericValue;
    active_subscriptions_by_tier: Record<string, NumericValue>;
  };
  top_companies: Array<{
    name: string;
    total_spent: NumericValue;
    last_payment: string | null;
    no_of_transactions: NumericValue;
    member_since: string;
  }>;
}

export interface FinanceDashboardState {
  timeRange: TimeRange;
  financeData: FinanceData | null;
  loading: boolean;
  error: string | null;
}

export const financeTimeRangeOptions: Array<{
  value: TimeRange;
  label: string;
}> = [
  { value: "24h", label: "Last 24 Hours" },
  { value: "7d", label: "Last 7 Days" },
  { value: "30d", label: "Last 30 Days" },
  { value: "90d", label: "Last 90 Days" },
  { value: "12m", label: "Last 12 Months" },
];
